module.exports = __webpack_public_path__ + "img/mainEventEnd_logo_250604.7fdddad1.png";